import React from "react"
import { useTranslation } from "react-i18next"

import classNames from "classnames"

import { WithClassName } from "shared/types/WithClassName"
import { NumberInput } from "shared/ui/input/number/NumberInput"

import { useRoomFormContext } from "../../contexts/RoomFormContext"

export interface RoomAirVolumePerPersonInputProps extends WithClassName {
  hideLabel?: boolean
}

export const RoomAirVolumePerPersonInput = React.memo(
  ({ className, hideLabel }: RoomAirVolumePerPersonInputProps) => {
    const { t } = useTranslation()
    const { isReadonly, isDisabled } = useRoomFormContext()

    return (
      <NumberInput.Root
        name="room.airVolumePerPerson"
        className={classNames("room-form__air-volume-per-person", className)}
        label={t("Room.airVolumePerPerson")}
        readonly={isReadonly}
        disabled={isDisabled}
        format={{ maximumFractionDigits: 2 }}
        step={0.5}
        data-testid="room__air-volume-per-person__input"
      >
        {!hideLabel && <NumberInput.Label />}
        <NumberInput.Group>
          <NumberInput.Decrement />
          <NumberInput.Focus>
            <NumberInput.Input />
          </NumberInput.Focus>
          <NumberInput.Increment />
        </NumberInput.Group>
        <NumberInput.Readonly />
        <NumberInput.ErrorMessage />
      </NumberInput.Root>
    )
  }
)
